import { isMagicbuyProject } from '@g/utils/projectUtils'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  pay ({ state, commit, rootState }, params) {
    if (isMagicbuyProject(rootState.project) && !params.payMethod) {
      params = { ...params, payMethod: 'creditdg' }
    }
    return rootState.axios.post('/jyo/v1frontend/kkren-vaorder/pay-or-refund', params)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
